import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-list-reviews.tsx
var LazyListReviews = lazy(() => import("./list-reviews-CPqr6Dia.js").then((n) => n.r).then((module) => ({ default: module.ListReviews })));
function ListReviews({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "list-reviews" }),
		children: /* @__PURE__ */ jsx(LazyListReviews, { ...props })
	});
}
function ListReviewsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "list-reviews" }),
		children: /* @__PURE__ */ jsx(LazyListReviews, { ...props })
	});
}
var useListReviewsContent = () => {
	return useMemo(() => ({ listReviews: { component: ListReviewsContent } }), []);
};
//#endregion
//#region src/use-list-reviews-index.tsx
var LazyListReviewsIndex = lazy(() => import("./list-reviews-index-D6DIv9yJ.js").then((module) => ({ default: module.ListReviewsIndex })));
function ListReviewsIndexContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "list-reviews-index" }),
		children: /* @__PURE__ */ jsx(LazyListReviewsIndex, { ...props })
	});
}
var useListReviewsIndexContent = () => {
	return useMemo(() => ({ listReviewsIndex: { component: ListReviewsIndexContent } }), []);
};
//#endregion
export { ListReviews, useListReviewsContent, useListReviewsIndexContent };
